
const time2string = function(value) {
	if (value == null || typeof value == 'undefined') {
		return '';
	}
	const hours =  Math.floor(value / 60);
	const mins =  value - (hours * 60);
	return hours + ':' + (mins < 10 ? '0' : '') + Math.round(mins);
};

const string2time = function(value) {
	if (value == null || typeof value == 'undefined') {
		return null;
	}
	const arr = value.split(':');
	const hours =  parseInt(arr[0]);
	const mins =  arr[1] ? parseInt(arr[1]) : 0;
	return hours * 60 + mins;
};

exports.string2time = string2time;
exports.time2string = time2string;


// WEBPACK FOOTER //
// ./src/helpers/time.js